<template>
  <v-tooltip location="top">
    <template #activator="{ props: tooltipProps }">
      <v-chip
        v-bind="tooltipProps"
        :color="status.color"
        :role="interactive ? 'link' : undefined"
        :tabindex="interactive ? 0 : undefined"
        :aria-label="tooltip"
        :size="size"
        variant="tonal"
        class="ncrm-privacy-status-chip"
        @click.stop="activate"
        @keydown.enter.stop.prevent="activate"
        @keydown.space.stop.prevent="activate"
      >
        <v-icon start :size="size === 'x-small' ? 12 : 14">{{ status.icon }}</v-icon>
        {{ $t(status.labelKey) }}
      </v-chip>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { buildPrivacyStatusTooltip, resolvePrivacyStatus } from "@/Utile/ncrmPrivacyStatus.mjs";

export default {
  name: "NcrmPrivacyStatusChip",
  emits: ["activate"],
  props: {
    state: { type: String, default: "undocumented" },
    breakdown: { type: [Object, String], default: null },
    total: { type: [Number, String], default: null },
    unclassified: { type: [Number, String], default: null },
    interactive: { type: Boolean, default: false },
    size: { type: String, default: "small" }, // `x-small` în rânduri dense (UI kit → Chip de status)
  },
  computed: {
    status() {
      return resolvePrivacyStatus(this.state);
    },
    tooltip() {
      return buildPrivacyStatusTooltip({
        t: this.$t.bind(this), state: this.state, breakdown: this.breakdown,
        total: this.total, unclassified: this.unclassified,
      });
    },
  },
  methods: {
    activate() {
      if (this.interactive) this.$emit("activate");
    },
  },
};
</script>
